
import { Component, Vue } from "vue-property-decorator";
import api from "@/api";
import store from "@/store";
import {imageUrl} from "@/utils/common";
import {ExportExcel} from "@/utils/exportFile";
import {Loading} from "element-ui";
@Component({
  components: {},
})
export default class business extends Vue {
  auditDialog = false;
  active = 0
  activeCur = 0
  // 字典
  config = store.state.system.config;
  d: any = {};

  loading = false;

  step: any = []

  // 机构确认
  poDialog = false
  poRiado = ''
  po_list = []
  surePo() {
    if(!this.poRiado) {
      this.$message.warning('请选择机构')
      return
    }
    api.post('A1016', {id: this.$route.query.id, poid: this.poRiado}).then(res => {
      this.$message.success('操作成功')
      this.poDialog = false
      this.getData()
    })
  }

  // 下载保函
  fullscreenLoading = false
  downloadBH() {
    this.fullscreenLoading = true
    api.post('A1015', {code: this.o.code}).then(res => {
      ExportExcel(res.base64, res.suffix, res.name)
    }).finally(() => {
      this.fullscreenLoading = false
    })
  }

  // 上传保函
  uploadBHDialog = false
  uploadBHInfo: any = {}
  uploadFile() {
    this.fileName = ''
    this.uploadBHInfo = {}
    this.uploadBHDialog = true
  }
  fileName: any = ''
  getDataBH(data: any) {
    this.uploadBHInfo.fileurl = imageUrl + data.filecode
    this.fileName = data.name
  }
  cancleBH() {
    this.uploadBHDialog = false
  }
  bcloading = false
  sureBH() {
    if(!this.uploadBHInfo.outorg_letter_code) {
      this.$message.warning('请输入保函编号')
      return
    }
    if(!this.uploadBHInfo.letter_at) {
      this.$message.warning('请输入出函时间')
      return
    }
    if(!this.uploadBHInfo.cost) {
      this.$message.warning('请输入保费')
      return
    }
    if(!this.uploadBHInfo.rate) {
      this.$message.warning('请输入费率')
      return
    }
    if(!this.uploadBHInfo.fileurl) {
      this.$message.warning('请上传保函文件')
      return
    }
    this.bcloading = true
    api.post('A1014', {...this.uploadBHInfo, id: this.$route.query.id}).then(res =>{
      this.uploadBHDialog = false
      this.$message.success('操作成功')
      this.getData()
    }).finally(() => {
      this.bcloading = false
    })
  }

  tabSwitchBtn(number: any) {
    if(this.o.status == 21) {
      this.active = number
      return
    }
    this.active = number - 1
    // this.getData()
  }

  // 上传协议
  uploadDialog = false
  uploadForm: any = {}
  toUpload(row: any) {
    this.uploadForm.file_id = row.id
    this.uploadForm.id = this.$route.query.id
    this.uploadForm.file_type = row.group
    this.uploadDialog = true
  }
  fileArray2: any = {}
  getDataUX(data: any) {
    this.fileArray2 = data
    this.uploadForm.filecode = data.filecode
    this.uploadForm.filename = data.name
  }
  sureUpload() {
    api.post('A1007', this.uploadForm).then(res => {
      this.$message.success('操作成功')
      this.uploadDialog = false
      this.fileArray2 = {}
      this.getData()
    })
  }

  // 变更签署方式
  qianshuDialog = false
  biangengType  = ''
  qianshuForm: any = {}
  biangeng(row: any, type: any) {
    this.qianshuForm.file_id = row.id
    this.qianshuForm.id = this.$route.query.id
    this.qianshuForm.file_type = row.group
    this.biangengType = type
    this.qianshuDialog = true
  }
  sureQS() {
    this.btnloading = true
    api.post('A1006', this.qianshuForm).then(res => {
      this.qianshuDialog = false
      this.$message.success('操作成功')
      this.getData()
    }).finally(() => {
      this.btnloading = false
    })
  }

  // 发送短信
  sendMsg(id: any) {
    api.post('A1005', {id}).then(res => {
      this.$message.success('操作成功')
      this.getData()
    })
  }

  // 复制
  copy (shareLink: any) {
    const input = document.createElement('textarea')// 直接构建input
    input.value = shareLink// 设置内容
    document.body.appendChild(input)// 添加临时实例
    input.select()// 选择实例内容
    document.execCommand('Copy')// 执行复制
    this.$message.success('复制成功')
    document.body.removeChild(input) // 删除临时实例
  }

  // 解保
  jiebaoDialog = false
  jiebaoInfo = {}
  jiebao() {
    this.jiebaoDialog = true
  }
  sureJB() {
    api.post('A1010', {id: this.o.id, ...this.jiebaoInfo}).then(res => {
      this.$message.success('操作成功')
      this.getData()
    })
  }
  // 重出保函
  chongchu() {
    this.$confirm('是否重出保函?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      api.post('A1009', {id: this.o.id}).then(res => {
        this.$message.success('操作成功')
        this.getData()
      })
    })
  }

  // 申请发票
  invoiceDialog = false;
  invoiceV: {
    [propName: string]: any;
  } = {
    code: "",
    type: "",
    name: "",
    credit_code: "",
    bank_name: "",
    bank_account: "",
    address: "",
    telephone: "",
    rece_realname: "",
    rece_phone: "",
    rece_address: "",
    email: "",
  };
  toInvoice() {
    this.invoiceDialog = true
  }
  invoiceSubmit() {
    if (!this.invoiceV.type) {
      this.$message.warning("请选择发票类型");
      return;
    }
    if (!this.invoiceV.name) {
      this.$message.warning("请输入发票抬头");
      return;
    }
    if (!this.invoiceV.credit_code) {
      this.$message.warning("请输入税号");
      return;
    }
    if (this.invoiceV.type === "e_ordinary") {
      if (!this.invoiceV.email) {
        this.$message.warning("请输入邮箱");
        return;
      }
      if (
              !/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(
                      this.invoiceV.email
              )
      ) {
        this.$message.warning("邮箱格式不正确");
        return;
      }
    } else {
      if (!this.invoiceV.bank_name) {
        this.$message.warning("请输入开户银行");
        return;
      }
      if (!this.invoiceV.bank_account) {
        this.$message.warning("请输入账号");
        return;
      }
      if (!this.invoiceV.address) {
        this.$message.warning("请输入地址");
        return;
      }
      if (!this.invoiceV.telephone) {
        this.$message.warning("请输入电话");
        return;
      }
      if (!this.invoiceV.rece_realname) {
        this.$message.warning("请输入收件人");
        return;
      }
      if (!this.invoiceV.rece_phone) {
        this.$message.warning("请输入收件电话");
        return;
      }
      if (!this.invoiceV.rece_address) {
        this.$message.warning("请输入收件地址");
        return;
      }
    }
    this.loading = true;
    api.post('A11002', {...this.invoiceV, op_id: this.o.op_id, order_code: this.o.code}).then(res => {
        this.$message.success("申请成功");
        this.invoiceDialog = false;
        this.getData()
    }).finally(() => {
      this.loading = false;
    })
  }


  // 取消订单
  cancleOrder() {
    this.$confirm('是否取消订单?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      api.post('A1004', {id: this.o.id}).then(res => {
        this.$message.success('操作成功')
        this.getData()
      })
    })

  }

  // 补充业务附件
  btnloading = false
  buchongDialog =  false
  buchongForm: any = {}
  buchong() {
    this.buchongDialog = true
  }
  fileList: any = []
  fileArray: any = []
  getDataU(data: any) {
    this.fileArray = [...this.fileArray, ...data]
  }
  sureBC() {
    let list: any = []
    this.fileArray.forEach((item: any) => {
      let str = ''
      str = item.filecode + '|' + item.name
      list.push(str)
    })
    this.btnloading = true
    api.post('A1010', {id: this.apply.id,appendixs: list.join(',')}).then(res => {
      this.fileList = []
      this.fileArray = []
      this.$message.success('操作成功')
      this.buchongDialog = false
      this.getData()
    }).finally(() => {
      this.btnloading = false
    })
  }

  // 更新审批进度
  renew() {
    api.post('A1008', {id: this.o.id}).then(res => {
      this.$message.success('操作成功')
      this.getData()
    })
  }

  // 去业务录单页面
  toBussnessDetail(row: any, type: any) {
    let q: any = {
      id: row.id
    }
    if(type == 'add') {
      q['form'] = 'order'
    }
    this.$router.push({
      path: '/order/bussnessDetailZS',
      query: {
        code: row.code,
        org_code: row.org_code,
        id: this.$route.query.id
      }
    })
  }

  // 变更业务信息
  change(row: any) {
    this.$router.push({
      path: '/order/bussnessDetailZS',
      query: {
        code: row.code,
        type: 'biangeng',
        org_code: row.org_code
      }
    })
  }

  //拒绝出函
  dialog = false
  refuseVal = ''
  refuse() {
    this.dialog = true
  }
  cancle() {
    this.refuseVal = ''
    this.dialog = false
  }
  sure() {
    api.post('A18004', {id: this.o.id, remark: this.refuseVal}).then(res => {
      this.$message.success('操作成功')
      this.dialog = false
      this.getData()
    })

  }

  loadingInstance: any
  getData() {
    this.loadingInstance = Loading.service({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(255, 255, 255, 0.7)'
    });
    api
        .post("A1002", {id: this.$route.query.id})
        .then((data: any) => {
          this.agree = data.agree;
          this.apply = data.apply ? data.apply : {};
          this.approve = data.approve;
          this.invoice = data.invoice;
          this.letter = data.letter;
          this.pay = data.pay;
          this.payee = data.payee;
          this.refund = data.refund;
          this.release = data.release;
          this.surrender = data.surrender;
          this.audit = data.audit;
          this.invoice = data.invoice;
          this.o = data.order;
          this.sale_log = data.sale_log;

          if(!data.order.org_id) {
            this.po_list = data.order.po_list
            // this.poDialog = true
          }

          switch (this.o.status) {
            case 21:
              this.step = [
                {title: '客户申请', step: 1},
                {title: '拒绝出函', step: 21},
              ]
              this.active = 21;
              this.activeCur = 21;
              break
            case 9:
              this.active = 0;
              this.activeCur = 0;
              break;
            case 20:
              this.active = 1;
              this.activeCur = 1;
              break;
            case 30:
              this.active = 2;
              this.activeCur = 2;
              break;
            case 50:
            case 40:
            case 60:
            // case 70:
              this.active = 3;
              this.activeCur = 3;
              break;
            // case 60:
            case 70:
              this.active = 4;
              this.activeCur = 4;
              break;
            case 80:
              this.active = 5;
              this.activeCur = 5;
              break;
            case 100:
              this.active = 6;
              this.activeCur = 6;
              this.step = [
                {title:'客户申请', step: 1},
                {title:'订单确认', step: 2},
                {title:'机构审批', step: 3},
                {title:'保费支付/协议签署', step: 4},
                {title:'保函出具', step: 5},
                {title:'保函解保', step: 6},
                {title:'订单退款', step: 7},
              ]
              break;
            case 90:
              this.active = 7;
              this.activeCur = 7;
              this.step = [
                {title:'客户申请', step: 1},
                {title:'订单确认', step: 2},
                {title:'机构审批', step: 3},
                {title:'保费支付/协议签署', step: 4},
                {title:'保函出具', step: 5},
                {title:'保函解保', step: 6},
                {title:'订单退款', step: 7},
              ]
              break;
          }
        })
        .finally(() => {
          this.loading = false;
          this.loadingInstance.close()
        })
        .catch(() => {
          this.d = {};
        });
  }

  agree: any;
  apply: any = {};
  approve: any;
  invoice: any;
  letter: any;
  pay: any;
  payee: any;
  refund: any;
  release: any;
  surrender: any;
  audit: any;
  sale_log: any;
  o: any = {};
  activated() {
    // this.loading = true;
    this.poRiado = ''
    this.step = [
      {title:'客户申请', step: 1},
      {title:'订单确认', step: 2},
      {title:'机构审批', step: 3},
      {title:'保费支付/协议签署', step: 4},
      {title:'保函出具', step: 5},
    ]
    this.d = {};
    this.getData()
  }
}
